export default __webpack_public_path__ + "static/media/avatar.81da6790.svg";